import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import type { TextFieldProps } from '@mui/material/TextField';
import { useState } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { FormTextField } from './form-text-field';
import { Icon } from './icon';

type FormPasswordFieldProps<T extends FieldValues> = Omit<TextFieldProps, 'name' | 'type'> & {
  name: FieldPath<T>;
  control: Control<T>;
  showLabel: string;
  hideLabel: string;
};

/** Password input bound to react-hook-form, with a show/hide toggle. */
export function FormPasswordField<T extends FieldValues>({
  showLabel,
  hideLabel,
  ...props
}: FormPasswordFieldProps<T>) {
  const [visible, setVisible] = useState(false);

  return (
    <FormTextField
      {...props}
      type={visible ? 'text' : 'password'}
      slotProps={{
        ...props.slotProps,
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                size="small"
                onClick={() => setVisible((v) => !v)}
                aria-label={visible ? hideLabel : showLabel}
                aria-pressed={visible}
              >
                <Icon name={visible ? 'eyeOff' : 'eye'} size={18} />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
